<template>

    <div class="helper-wrapper contents" :style="helperPos" :class="{ clsng : Global.tempHelperClosingOverlay }">
        <div class="duplicate-outer">
            <div class="btn main txt-blk" @click.prevent="triggerContent">
                <span class="hvr"></span>
                <span class="ico">
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM11.5 11.5V6.5H14.5V11.5H19.5V14.5H14.5V19.5H11.5V14.5H6.5V11.5H11.5Z" fill="black"/>
                    </svg>
                </span>
                <span class="txt">Add new content</span>
            </div>
        </div>
        <div class="tooltip-wrapper">
            <div class="tooltip-outer" @click.prevent="$parent.helperBgClick">
                <div class="tooltip">
                    <span class="ico">
                        <svg width="22" height="22" viewBox="0 0 27 27" fill="none">
                        <circle cx="13.5" cy="13.4999" r="12.25" stroke="url(#paint0_linear_1539_2667)" stroke-width="2.5"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5 10.2499C14.4665 10.2499 15.25 9.46638 15.25 8.49988C15.25 7.53338 14.4665 6.74988 13.5 6.74988C12.5335 6.74988 11.75 7.53338 11.75 8.49988C11.75 9.46638 12.5335 10.2499 13.5 10.2499ZM13 11.9999C12.4477 11.9999 12 12.4476 12 12.9999V17.9999C12 18.5522 12.4477 18.9999 13 18.9999H14C14.5523 18.9999 15 18.5522 15 17.9999V12.9999C15 12.4476 14.5523 11.9999 14 11.9999H13Z" fill="url(#paint1_linear_1539_2667)"/>
                        <defs>
                        <linearGradient id="paint0_linear_1539_2667" x1="27" y1="26.9999" x2="-2.28482" y2="24.2395" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#F3CA54"/>
                        <stop offset="1" stop-color="#FFBB36"/>
                        </linearGradient>
                        <linearGradient id="paint1_linear_1539_2667" x1="15.25" y1="18.9999" x2="11.4229" y2="18.8968" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#F3CA54"/>
                        <stop offset="1" stop-color="#FFBB36"/>
                        </linearGradient>
                        </defs>
                        </svg>
                    </span>
                    <p class="txt-main">Start by adding your first content and configure its monetization!</p>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import Global from '../lib/GlobalState'

    export default {

        name: 'ContentsHelperOverlay',

        components: {
            
        },

        props: {
            
        },

        data() {
            return {
                Global
            }
        },

        computed: {
            helperPos() {
                return { top : this.Global.ContentsHelperOverlayPos.y + 'px', left : this.Global.ContentsHelperOverlayPos.x + 'px' }
            }
        },

        methods: {

            triggerContent() {
                this.$parent.helperBgClick()
                setTimeout(() => { this.$parent.openContentOverlay() }, 800)
            }

        }
    }
</script>